export default __webpack_public_path__ + "assets/images/02af86d6cb3440a7c7cc9c172dab6709.svg";